import React, { useEffect, useState } from 'react'

import { map } from "lodash" //https://lodash.com/docs/4.17.15#map  //find
import { Grid } from '@material-ui/core';
import { FormControl, Button } from 'react-bootstrap';

export default function PatientAgreement(props) {

    const { setMoreDataPdf, sendForm } = props


    const inputsBuilder = [
        {
            'name' : 'date1',
            'label' : 'שנעררך ונחתם ב',
            'defaultValue': '',
            
        },
        {
            'name' : 'date2',
            'label' : 'ביום',
            'defaultValue': '',
            
        },
        {
            'name' : 'date3',
            'label' : 'בחודש',
            'defaultValue': '',
            
        },
        {
            'name' : 'date4',
            'label' : 'בשנת',
            'defaultValue': '',
            
        },
        {
            'name' : 'workerChange',
            'label' : 'החלפה מטפלים למשך',
            'defaultValue': '',
            
        },
        {
            'name' : 'pay',
            'label' : 'תשלום השמת העובד בסך',
            'defaultValue': '',
            
        },
        
        
    ]


    const [formData, setFormData] = useState(defaultValueForm(inputsBuilder));

    
    const onChange = (e) => {

        //console.log(e.target.name, e.target.value);
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        })

    }

    

    useEffect(() => {
     
        setMoreDataPdf(formData);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData])
    

    const submit = () => { 
        
        sendForm();

    }

    //console.log('inputsBuilder', inputsBuilder);
    //console.log('formData', formData);
    

  return (
    <div>

        <h3 style={{margin: '0 0 30px 0'}}>נא להשלים פרטים:</h3>
        <Grid className='line' container spacing={2}  alignItems="center"  /* justifyContent="right" */ direction="row" >

            <Grid item md={12} >

                <header>
                    <h4>{inputsBuilder[0].label}</h4>
                </header>

                <FormControl onChange={onChange}
                    //as="textarea"
                    name={inputsBuilder[0].name}
                    value={formData[inputsBuilder[0].name]}
                />
            </Grid>

            <Grid item md={4} >

                <header>
                    <h4>{inputsBuilder[1].label}</h4>
                </header>

                <FormControl onChange={onChange}
                    //as="textarea"
                    name={inputsBuilder[1].name}
                    value={formData[inputsBuilder[1].name]}
                />
            </Grid>

            <Grid item md={4} >

                <header>
                    <h4>{inputsBuilder[2].label}</h4>
                </header>

                <FormControl onChange={onChange}
                    //as="textarea"
                    name={inputsBuilder[2].name}
                    value={formData[inputsBuilder[2].name]}
                />
            </Grid>

            <Grid item md={4} >

                <header>
                    <h4>{inputsBuilder[3].label}</h4>
                </header>

                <FormControl onChange={onChange}
                    //as="textarea"
                    name={inputsBuilder[3].name}
                    value={formData[inputsBuilder[3].name]}
                />
            </Grid>

            <Grid item md={4} >

                <header>
                    <h4>{inputsBuilder[4].label}</h4>
                </header>

                <FormControl onChange={onChange}
                    //as="textarea"
                    name={inputsBuilder[4].name}
                    value={formData[inputsBuilder[4].name]}
                />
            </Grid>

            <Grid item md={4} >

                <header>
                    <h4>{inputsBuilder[5].label}</h4>
                </header>

                <FormControl onChange={onChange}
                    //as="textarea"
                    name={inputsBuilder[5].name}
                    value={formData[inputsBuilder[5].name]}
                />
            </Grid>

        </Grid>

        <div style={{textAlign: 'center',margin: '30px 0 0 0'}}>
            <Button className='sendBtn' onClick={submit} size="lg" variant="success" >שליחה</Button>
        </div>
    </div>
  )

}

function defaultValueForm(inputsBuilder) {

    let objReturn = {};

    //console.log(savedData);
      
    map(inputsBuilder, item => {
              
        objReturn[item.name] = item.defaultValue
        
    })
    
    return objReturn;

}

